import type { Theme } from "@mui/material/styles";
import type { AppPublicSharePageStyles } from "../types";

export function buildPublicSharePageStyles(_theme: Theme): AppPublicSharePageStyles {
  return {
    page: {
      height: "100dvh",
      minHeight: "100vh",
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      overflow: "hidden",
      bgcolor: "background.default",
      color: "text.primary",
    },
    pageCentered: {
      height: "100dvh",
      minHeight: "100vh",
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      overflow: "hidden",
      bgcolor: "background.default",
      color: "text.primary",
      alignItems: "center",
      justifyContent: "center",
      p: 3,
    },
    sidebar: {
      flexShrink: 0,
      width: { xs: "100%", md: 300 },
      maxWidth: { xs: "100%", md: 320 },
      borderRight: { md: 1 },
      borderBottom: { xs: 1, md: 0 },
      borderColor: "divider",
      bgcolor: "background.paper",
      display: "flex",
      flexDirection: "column",
      overflow: "auto",
      maxHeight: { xs: "42vh", md: "none" },
    },
    mainContent: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      px: { xs: 0.5, sm: 1 },
      py: 0.5,
    },
  };
}
